// React dependencies
import React from 'react';

// External dependencies
import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';

// Internal dependencies
import Colours from '../../styles/colours';
import TagsInput from '../common/TagsInput';
import { formatTag } from '../../common/util';

const PoiTags = (props) => (
  <>
    {
      props.isLoading && (
        <div className="my-2 d-flex justify-content-center">
          <CircularProgress color={Colours.Purple} size={14} />
        </div>
      )
    }
    <div className="w-100">
      <TagsInput
        data={props.userTags}
        onChange={(values) => {
          const formattedUserTags = values.map((value) => (formatTag(value)));
          props.onUserTagsChange(formattedUserTags);
        }}
        disabled={props.disabled}
      />
    </div>
  </>
);

PoiTags.defaultProps = {
  isLoading:        false,
  userTags:         [],
  onUserTagsChange: () => {},
  disabled:         false,
};

PoiTags.propTypes = {
  isLoading:        PropTypes.bool,
  userTags:         PropTypes.arrayOf(PropTypes.string),
  onUserTagsChange: PropTypes.func,
  disabled:         PropTypes.bool,
};

export default PoiTags;
